import { http } from "../core";
import { URL } from "./_url";
import { StatusCode } from "../constant";
import { LeadData } from "../types";
export const apiFetchDivisionsList = async () => {
  const response = await http.get(URL.DIVISION_LIST());
  if (response && response.status >= StatusCode.BADREQUEST) {
    console.log('Error fetching divisions list:', response.status, response.statusText);
    throw new Error(response.status);
  }
  return response || null;
};